import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // 1. Get token from localStorage
    const token = localStorage.getItem('token');

    // 2. Attach token to headers if it exists
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    // 3. Handle the response and watch for 401 errors
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // If the backend returns 401 (Unauthorized)
        if (error.status === 401 || error.status === 503) {
          localStorage.removeItem('token'); // Clear the invalid token
          
          // Check if the error message is specifically about the double login
          if (error.error && error.error.message && error.error.message.includes('Another device')) {
            alert('Your session is no longer valid because you logged in on another device.');
          }

          this.router.navigate(['/auth/login']);
        }
        return throwError(error);
      })
    );
  }
}